const consentPage = window.location.pathname === '/corporate/consent'
  || window.location.pathname === '/advocate_consent';

const corporatePage = window.location.pathname.includes('corporate')
  || window.location.pathname.includes('/influitive/companies')
  || window.location.pathname.includes('forum/review')
  || window.location.pathname.includes('forum/admin')
  || window.location.host.startsWith('admin.');

import 'modules/advocate-nav';
import 'modules/challenges-carousel';

if (!consentPage) {
  if (corporatePage) {
    import('modules/targeting-editor');
    document.getElementById('infl-fe-admin-nav') && import('modules/admin-nav');
    document.getElementById('infl-fe-advocate-consent-settings') && import('modules/advocate-consent-settings');
    document.getElementById('infl-fe-advocate-table') && import('modules/advocate-table');
    document.getElementById('infl-fe-campaigns') && import('modules/campaigns');
    document.getElementById('infl-fe-hub-switcher') && import('modules/hub-switcher');
    document.getElementById('infl-fe-message-settings') && import('modules/message-settings');
    document.getElementById('infl-fe-multilingual') && import('modules/multilingual');
    document.getElementById('infl-fe-roi-settings') && import('modules/roi-settings');
    document.getElementById('infl-fe-roi-table') && import('modules/roi-view');
    document.getElementById('infl-fe-streaker-settings') && import('modules/streaker-settings');
    document.getElementById('infl-fe-advocacy-picker') && import('modules/advocacy-picker');
    document.getElementById('infl-fe-admin-question-challenge') && import('modules/admin-question-challenge');
  } else {
    import('modules/mountain-dew');
    import('modules/leaderboard');
    document.getElementById('infl-fe-advocate-notifications') && import('modules/advocate-notifications');
    document.getElementById('infl-fe-challenge-player-loader') && import('modules/challenge-player-loader');
    document.getElementById('infl-fe-streaker-challenge-page') && import('modules/streaker-challenge-page');
    document.getElementById('infl-fe-profile') && import('modules/profile');
    (document.getElementById('infl-fe-streaker-mobile')
      || document.getElementById('infl-fe-streaker-desktop')) && import('modules/streaker');
  }
}
